function cov_e50tdixb8() {
  var path = "/app/src/utils/create-normalize-checking-number.tsx";
  var hash = "57436e0ee70544ea2cf20c5e30196d03f6934724";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/create-normalize-checking-number.tsx",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "1": {
        start: {
          line: 2,
          column: 54
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "2": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 5,
          column: 5
        }
      },
      "3": {
        start: {
          line: 4,
          column: 6
        },
        end: {
          line: 4,
          column: 26
        }
      },
      "4": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 20,
          column: 5
        }
      },
      "5": {
        start: {
          line: 8,
          column: 18
        },
        end: {
          line: 8,
          column: 54
        }
      },
      "6": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 12,
          column: 7
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 27
        }
      },
      "8": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 19,
          column: 7
        }
      },
      "9": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 40
        }
      },
      "10": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 28
        }
      },
      "11": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      "12": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 19
        }
      },
      "13": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 54
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 2,
            column: 54
          },
          end: {
            line: 2,
            column: 55
          }
        },
        loc: {
          start: {
            line: 2,
            column: 70
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 4
          },
          end: {
            line: 5,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 4
          },
          end: {
            line: 5,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 8
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 8
          },
          end: {
            line: 3,
            column: 27
          }
        }, {
          start: {
            line: 3,
            column: 31
          },
          end: {
            line: 3,
            column: 45
          }
        }, {
          start: {
            line: 3,
            column: 49
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 12,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 12,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 10
      },
      "4": {
        loc: {
          start: {
            line: 10,
            column: 10
          },
          end: {
            line: 10,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 10
          },
          end: {
            line: 10,
            column: 38
          }
        }, {
          start: {
            line: 10,
            column: 42
          },
          end: {
            line: 10,
            column: 58
          }
        }],
        line: 10
      },
      "5": {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 14
      },
      "6": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      },
      "7": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 33
          }
        }, {
          start: {
            line: 22,
            column: 37
          },
          end: {
            line: 22,
            column: 59
          }
        }, {
          start: {
            line: 22,
            column: 63
          },
          end: {
            line: 22,
            column: 73
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "57436e0ee70544ea2cf20c5e30196d03f6934724"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_e50tdixb8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_e50tdixb8();
cov_e50tdixb8().s[0]++;
export var createNormalizeCheckingNumber = function createNormalizeCheckingNumber(descriptionError, defaultValue) {
  cov_e50tdixb8().f[0]++;
  cov_e50tdixb8().s[1]++;
  return function (value) {
    cov_e50tdixb8().f[1]++;
    cov_e50tdixb8().s[2]++;
    if ((cov_e50tdixb8().b[1][0]++, value === undefined) || (cov_e50tdixb8().b[1][1]++, value === null) || (cov_e50tdixb8().b[1][2]++, value === '')) {
      cov_e50tdixb8().b[0][0]++;
      cov_e50tdixb8().s[3]++;
      return defaultValue;
    } else {
      cov_e50tdixb8().b[0][1]++;
    }
    cov_e50tdixb8().s[4]++;
    if (typeof value === 'string') {
      cov_e50tdixb8().b[2][0]++;
      var num = (cov_e50tdixb8().s[5]++, value.replace(/,/g, '.'));
      cov_e50tdixb8().s[6]++;
      if ((cov_e50tdixb8().b[4][0]++, Number.isFinite(Number(num))) && (cov_e50tdixb8().b[4][1]++, Number(num) >= 0)) {
        cov_e50tdixb8().b[3][0]++;
        cov_e50tdixb8().s[7]++;
        return Number(num);
      } else {
        cov_e50tdixb8().b[3][1]++;
      }
      cov_e50tdixb8().s[8]++;
      if (Number.isNaN(Number(num))) {
        cov_e50tdixb8().b[5][0]++;
        cov_e50tdixb8().s[9]++;
        // eslint-disable-next-line no-console
        console.error(descriptionError);
        cov_e50tdixb8().s[10]++;
        return defaultValue;
      } else {
        cov_e50tdixb8().b[5][1]++;
      }
    } else {
      cov_e50tdixb8().b[2][1]++;
    }
    cov_e50tdixb8().s[11]++;
    if ((cov_e50tdixb8().b[7][0]++, typeof value === 'number') && (cov_e50tdixb8().b[7][1]++, Number.isFinite(value)) && (cov_e50tdixb8().b[7][2]++, value >= 0)) {
      cov_e50tdixb8().b[6][0]++;
      cov_e50tdixb8().s[12]++;
      return value;
    } else {
      cov_e50tdixb8().b[6][1]++;
    }
    cov_e50tdixb8().s[13]++;
    return defaultValue;
  };
};